<!-- 赌球竞猜 金币版 --->
<template>
<div class="guessing-gold">
    <div class="top-contrl cont-row" :class="{islogin:isLogin}">
        <!-- <div class="cont my-info media-show">
            <div class="my-gold-info">
                <img :src="require('../assets/gold-small.png')" height="20" alt="">
                <div class="text" @click="myGoldStatus = true">金币123</div>
                <div class="recharge">立即充值</div>
            </div>
            <div class="my-guessing-info" @click="guessingStatus = true">
                <img :src="require('../assets/football.png')" alt="">
                <div class="text">竞猜12次</div>
                
            </div>
        </div> -->
        <div class="flex-cont cont-row">
            <div class="tab">
                <div class="item" :class="{active:indent == 1}" @click="tabChange(1)">金币竞猜</div>
                <div class="item" :class="{active:indent == 2}"  @click="tabChange(2)">往日赛程</div>
            </div>
            <!-- <div class="title-text">金币竞猜</div> -->
            <!-- <div class="rules" @click="rulesStatus = true">竞猜规则&gt;</div> -->
        </div>
        <div class="cont cont-row gold-geussing" v-if="isLogin">
            <div class="my-gold-info">
                <img :src="require('../assets/gold-small.png')" height="20" alt="">
                <div class="text" @click="myGoldStatus = true">金币{{myGoldInfo.gold}}</div>
                <div class="recharge" @click="rechargeStatus=true">立即充值</div>
            </div>
            <div class="my-guessing-info" @click="guessingStatus = true" >
                <img :src="require('../assets/football.png')" alt="">
                <div class="text">我的竞猜</div>
                
            </div>
        </div>
        <div class="cont go-login" v-else @click="goToLogin">登录</div>
    </div>
    <ul class="game-list" v-loading="pageLoading">
        <li v-for="item in list.slice(0,showLg)" :key="item.id">
            <GuessingItemGold :info="item" @success="getMyInfo" />
        </li>
        
    </ul>
    <!-- <div class="look-more" @click="foldChange(false)" v-if="foldStatus">查看全部 <i class="el-icon-arrow-down"></i></div>
    <div class="look-more" @click="foldChange(true)"  v-if="!foldStatus">收起 <i class="el-icon-arrow-up"></i></div> -->
    <GuessingRulesGold :status.sync="rulesStatus" />
    <MyGuessingGold :status.sync="guessingStatus" />
    <MyGold :status.sync="myGoldStatus" />
    <GoldRecharge :status.sync="rechargeStatus" @success="getMyInfo" />
</div>
</template>
<script>
import GuessingItemGold from './guessing-item-gold.vue'
import GuessingRulesGold from '../dialog-gold/guessing-rules-gold.vue'
import MyGuessingGold from '../dialog-gold/my-guessing-gold.vue'
import MyGold from '../dialog-gold/my-gold.vue'
import GoldRecharge from '../dialog-gold/recharge.vue'
import {hostBuild} from '@/utils/utils.js'
export default {
    name:'GuessingGold',
    components:{GuessingItemGold,GuessingRulesGold,MyGuessingGold,MyGold,GoldRecharge},
    data(){
        return {
            list:[],
            indent:1,
            rulesStatus:false,
            guessingStatus:false,
            myGoldStatus:false,
            myGoldInfo:{
                gold:0,
                count:0
            },
            rechargeStatus:false,
            pageLoading:false,
            foldStatus:true,
            showLg:10,
       
           
        }
    },
    computed:{
        isLogin(){
            return this.$store.getters.isLogin;
            //return false;
        }

    },
    created(){
        this.getMyInfo()
        this.getGuessingList();
    },
    methods:{
        tabChange(index){
            if( this.indent == index) return false;
            this.indent = index;
            this.getGuessingList()
        },
        foldChange(bool){
            this.foldStatus = bool;
            if( this.foldStatus ){
                this.showLg = 10;
            }else{
                this.showLg = this.list.length;
            }
        },
        async getMyInfo(){
            let result = await this.$axios.get('/worldcup2022/gold/coin/my/user/info');
            if( result.code == 0  ){
                console.log('金币版信息--->',result);
                this.myGoldInfo.gold = result.data.coin;
                this.myGoldInfo.count = result.data.count;
                this.$store.dispatch('userAddProperty',{gold:result.data.coin})
            }
        },
        goToLogin(){
            let path ='/login?redirect=' + encodeURIComponent(window.location.href);
            window.location.href = hostBuild(path,'account');
        },
        async getGuessingList(){
            let url = ''
            if( this.indent == 1 ){
                url = '/worldcup2022/gold/coin/result/games/ongoing?cointype=2'
            }else{
                url = '/worldcup2022/gold/coin/result/games/history?cointype=2'
            }
            this.pageLoading = true;
            let result = await this.$axios.get(url)
            this.pageLoading = false;
            if(result.code == 0 ){
                console.log('jinbi--->', result);
                this.list = result.data.games;
            }
        },
    }
}
</script>
<style lang="less" scoped>
.guessing-gold{
    background: #fff; padding: 30px 40px 20px; margin-bottom: 30px;
    .top-contrl{margin-bottom: 20px;}
    .go-login{
        user-select: none; cursor: pointer;
        &:hover{color: #e43a3a;}
    }
    .tab{
        display: flex; align-items: center;
        .item{
            color: #5F3612; font-size: 18px; margin-right: 20px;  opacity: 0.7; cursor: pointer; user-select: none;
            &.active{opacity: 1;font-weight: bold; font-size: 20px;}
        }
    }
    .title-text{color: #5F3612; font-size: 20px; margin-right: 10px; font-weight: bold;}
    .rules{color: #5F3612; font-size: 16px; text-decoration: underline; cursor: pointer;}
    .my-gold-info{
        width: 260px; height: 42px; display: flex; align-items: center; padding: 0 20px; border-radius: 6px;
        background-image: linear-gradient(#FFB607,#FC7703); 
        box-shadow: 0 6px 0px #833200;
         box-sizing: border-box;
        .text{
            flex:1; font-size: 16px; color: #fff; font-weight: 600; margin-left: 5px;
        }
        .recharge{color: #fff; text-decoration: underline; font-size: 14px; cursor: pointer;}
    }
    .my-guessing-info{
        display: flex; align-items: center; width: 150px; height: 42px; margin-left: 20px;
        background: linear-gradient(#D030FE,#6D33FC);
        border-radius: 6px; box-shadow: 0 6px 0px #581686;
        box-sizing: border-box; padding: 0 20px;
        user-select: none; cursor: pointer;
        .text{
            flex:1; font-size: 16px; color: #fff;  margin-left: 5px;
        }
    }
    .game-list{
        margin:0 -12px; display: flex; flex-wrap: wrap;
        li{padding: 0 12px; margin-bottom: 30px; width: 50%; box-sizing: border-box;}
    }
    .look-more{width: 100%;
        border-radius: 4px; font-size: 16px; line-height: 36px; color: #999; text-align: center;
        user-select: none; cursor: pointer;
        &:hover{text-decoration: underline;}
    }
}
.media-show{display: none;}
@media screen and (max-width:768px){
    .media-show{display:flex;}
    .full-show{display: none;}
    .guessing-gold{
        padding: 0; margin-bottom: 0;
        .my-info{align-items: flex-start; margin-bottom: 20px; width: 100%;}
        .top-contrl{
            &.islogin{
                flex-direction: column-reverse; justify-content: flex-start; align-items: flex-start;
                .gold-geussing{margin-bottom: 20px;}
            }
            //flex-direction: column; align-items: flex-start;
        }
        .game-list{
            margin: 0;
            li{width:100%; margin-bottom: 20px; padding: 0;}
        }
        .gold-geussing{
            width: 100%;
            .my-gold-info{
                flex:2; width: auto;padding: 0 10px;
                .text{
                    flex:1; font-size: 14px; color: #fff; font-weight: 600; margin-left: 5px; user-select: none; cursor: pointer;
                }
                .recharge{color: #fff; text-decoration: underline; font-size: 14px; cursor: pointer;}
            }
            .my-guessing-info{
                flex:1;width: auto; padding: 0 10px;
                .text{
                    flex:1; font-size: 14px; color: #fff;  margin-left: 5px;
                }
            }
        }
        
    }
}
</style>